var map = {
	"./admin-dashboard/absent-time.png": "f355",
	"./admin-dashboard/active-employees.png": "62d0",
	"./admin-dashboard/company.png": "fbd5",
	"./admin-dashboard/filed-work-tree.png": "2abb",
	"./admin-dashboard/inactive-employees.png": "c02d",
	"./admin-dashboard/late-tortoise.png": "8571",
	"./admin-dashboard/leave-distribution.png": "a14d",
	"./admin-dashboard/leave-timer.png": "638f",
	"./admin-dashboard/other-workplace.png": "e99a",
	"./admin-dashboard/present-employee.png": "c204",
	"./admin-dashboard/team-availability.png": "3029",
	"./admin-dashboard/team-updates.png": "37a6",
	"./admin-dashboard/work-from-home.png": "a12d",
	"./asset-management/asset-delete.png": "23ff",
	"./benefits/esop/man-with-shares.png": "7f2f",
	"./billing/demo-booking.png": "6253",
	"./billing/discount-offer.png": "b89f",
	"./billing/discount-panel.png": "a90f",
	"./billing/empty-plan.png": "27e6",
	"./billing/help-icon.png": "b914",
	"./billing/money-back-guarantee.png": "08d4",
	"./billing/offer-icon.png": "daaa",
	"./billing/special-offer.png": "cd15",
	"./billing/video.png": "d1e6",
	"./common/add-employees.png": "34f9",
	"./common/block.png": "28df",
	"./common/cannyhr-logo.png": "1b8d",
	"./common/delete-bin.png": "d164",
	"./common/empty-search.png": "4e7c",
	"./common/exit_form.png": "a0c8",
	"./common/export-csv-file.png": "57db",
	"./common/export-xlsx-file.png": "54b3",
	"./common/file-preview.png": "715b",
	"./common/green-left-background.png": "9e1b",
	"./common/green-right-background.png": "fe82",
	"./common/hrapp-logo.png": "c4a3",
	"./common/human-error-image.png": "d5a7",
	"./common/idea-bulb.png": "ee46",
	"./common/initial-fetch-error-image.png": "1d66",
	"./common/no-active-employees.png": "152a",
	"./common/no-records.png": "6b99",
	"./common/notify-email.png": "cb8c",
	"./common/popover-empty.png": "a776",
	"./compliance-management/document-generator/document-generator-empty.png": "6c11",
	"./compliance-management/document-generator/document-signature-empty.png": "be53",
	"./compliance-management/signatories/already-signed.png": "497f",
	"./compliance-management/signatories/signature-error.png": "9ceb",
	"./compliance-management/signatories/url-expired.png": "ed53",
	"./core-hr/custom-group-no-records.png": "919a",
	"./core-hr/empty-work-schedule.png": "f95c",
	"./dashboard/actions-empty-image.png": "396c",
	"./dashboard/at-work.png": "53bf",
	"./dashboard/benefits-empty-image.png": "c961",
	"./dashboard/birthday-cake-img.png": "61dd",
	"./dashboard/birthday-celebration.png": "bafa",
	"./dashboard/calendar.png": "1da7",
	"./dashboard/company-update.png": "c6e3",
	"./dashboard/company-updates-empty-image.png": "37c9",
	"./dashboard/expenses-empty-image.png": "7dcd",
	"./dashboard/field.png": "ad11",
	"./dashboard/gps-not-accurate.png": "031b",
	"./dashboard/holiday-empty-image.png": "707d",
	"./dashboard/holidays.png": "c285",
	"./dashboard/late.png": "6438",
	"./dashboard/leave-closure-warning.png": "73b8",
	"./dashboard/leave-history.png": "0b55",
	"./dashboard/location-not-found.png": "313b",
	"./dashboard/mild-smiley.png": "d6b8",
	"./dashboard/office.png": "3fa1",
	"./dashboard/on-duty.png": "24d1",
	"./dashboard/payslip-empty-image.png": "eacf",
	"./dashboard/sad-face-avatar.png": "2245",
	"./dashboard/tax-empty-image.png": "37ad",
	"./dashboard/timeoff-empty-image.png": "7ece",
	"./dashboard/work-from-home.png": "5848",
	"./employee-monitoring/activity-tracker/accpet-invite-error.png": "1bda",
	"./employee-monitoring/activity-tracker/activate-admin-bg.png": "367b",
	"./employee-monitoring/activity-tracker/activate-admin-download-app.png": "d502",
	"./employee-monitoring/activity-tracker/activate-admin-info.png": "3537",
	"./employee-monitoring/activity-tracker/activate-employee-bg.png": "77af",
	"./employee-monitoring/activity-tracker/activate-employee.png": "53fa",
	"./employee-monitoring/activity-tracker/activity-monitor-trial-expired.png": "2967",
	"./employee-monitoring/activity-tracker/activity-tracked.png": "07fc",
	"./employee-monitoring/activity-tracker/activity-tracker-error-screen.png": "351d",
	"./employee-monitoring/activity-tracker/activity-tracker-logo.png": "ddbb",
	"./employee-monitoring/activity-tracker/add-more-member-licence.png": "accd",
	"./employee-monitoring/activity-tracker/admin-activate-btn.png": "9ecf",
	"./employee-monitoring/activity-tracker/browser-chrome-logo.png": "0e4b",
	"./employee-monitoring/activity-tracker/browser-firefox-logo.png": "7bbc",
	"./employee-monitoring/activity-tracker/browser-ie-logo.png": "1843",
	"./employee-monitoring/activity-tracker/browser-msedge-logo.png": "5a92",
	"./employee-monitoring/activity-tracker/browser-opera-logo.png": "6d53",
	"./employee-monitoring/activity-tracker/browser-safari-logo.png": "39e8",
	"./employee-monitoring/activity-tracker/computer-activities.png": "a70a",
	"./employee-monitoring/activity-tracker/download-linux-app-btn.png": "c577",
	"./employee-monitoring/activity-tracker/download-mac-app-btn.png": "3af1",
	"./employee-monitoring/activity-tracker/download-windows-app-btn.png": "db4b",
	"./employee-monitoring/activity-tracker/emp-intro-request-access.png": "f9f3",
	"./employee-monitoring/activity-tracker/emp-invite-request-access-btn.png": "7b2b",
	"./employee-monitoring/activity-tracker/emp-not-invited-learn-more.png": "b43b",
	"./employee-monitoring/activity-tracker/graph-blue.png": "b419b",
	"./employee-monitoring/activity-tracker/graph-green.png": "8f6d",
	"./employee-monitoring/activity-tracker/graph-pink.png": "5fa9",
	"./employee-monitoring/activity-tracker/graph-purple.png": "2027",
	"./employee-monitoring/activity-tracker/intro-screen-bg-blue.png": "304b",
	"./employee-monitoring/activity-tracker/intro-screen-bg-green.png": "22a1",
	"./employee-monitoring/activity-tracker/intro-screen-bg-grey.png": "9e57",
	"./employee-monitoring/activity-tracker/intro-screen-bg-orange.png": "2504",
	"./employee-monitoring/activity-tracker/intro-screen-bg-pink.png": "e43a",
	"./employee-monitoring/activity-tracker/intro-screen-help-female.png": "b54b",
	"./employee-monitoring/activity-tracker/invite-import.png": "1cdb",
	"./employee-monitoring/activity-tracker/invite-manual.png": "4d5a",
	"./employee-monitoring/activity-tracker/invite-members-btn.png": "1d37",
	"./employee-monitoring/activity-tracker/linked-in-bg.png": "0d98",
	"./employee-monitoring/activity-tracker/linked-in-info.png": "4335",
	"./employee-monitoring/activity-tracker/linux-logo.png": "43aa",
	"./employee-monitoring/activity-tracker/low-activity.png": "85bd",
	"./employee-monitoring/activity-tracker/mac-download.png": "8478",
	"./employee-monitoring/activity-tracker/mac-logo.png": "acd6",
	"./employee-monitoring/activity-tracker/member-statistics.png": "ebec",
	"./employee-monitoring/activity-tracker/my-activity.png": "daea",
	"./employee-monitoring/activity-tracker/no-activities.png": "9a0d",
	"./employee-monitoring/activity-tracker/no-activity.png": "2322",
	"./employee-monitoring/activity-tracker/no-apps-activity.png": "478f",
	"./employee-monitoring/activity-tracker/no-insights-activity.png": "ebeca",
	"./employee-monitoring/activity-tracker/no-records-my-team-actiivity.png": "d790",
	"./employee-monitoring/activity-tracker/no-records-team-members.png": "5d65",
	"./employee-monitoring/activity-tracker/no-screenshots-captured.png": "66ca",
	"./employee-monitoring/activity-tracker/no-urls-activity.png": "60b5",
	"./employee-monitoring/activity-tracker/org-time-zone.png": "61b5",
	"./employee-monitoring/activity-tracker/privacy-mode-alert.png": "f147",
	"./employee-monitoring/activity-tracker/privacy-mode-icon.png": "3550",
	"./employee-monitoring/activity-tracker/productive-time.png": "9066",
	"./employee-monitoring/activity-tracker/productivity.png": "7fb0",
	"./employee-monitoring/activity-tracker/time-and-date.png": "3e5d",
	"./employee-monitoring/activity-tracker/url-search-empty.png": "2f1e",
	"./employee-monitoring/activity-tracker/user-active-time.png": "072c",
	"./employee-monitoring/activity-tracker/user-help.png": "b4f6",
	"./employee-monitoring/activity-tracker/windows-logo.png": "b3ae",
	"./employee-monitoring/dashboard/appsurl.png": "621d",
	"./employee-monitoring/dashboard/screen-capture.png": "b7e1",
	"./employee-monitoring/reports/apps-reports.png": "f8fc",
	"./employee-monitoring/reports/asset-reports.png": "3c39",
	"./employee-monitoring/reports/attendance-reports.png": "de4b",
	"./employee-monitoring/reports/consolidated-apps-urls.png": "c571",
	"./employee-monitoring/reports/custom-range-calendar.png": "34a5",
	"./employee-monitoring/reports/daily-calendar.png": "f210",
	"./employee-monitoring/reports/efficiency-reports.png": "ba01",
	"./employee-monitoring/reports/empty-header.png": "bec1",
	"./employee-monitoring/reports/file-event.png": "e0bf",
	"./employee-monitoring/reports/location.png": "698d",
	"./employee-monitoring/reports/low-activity-reports.png": "b861",
	"./employee-monitoring/reports/monthly-calendar.png": "1701",
	"./employee-monitoring/reports/monthly-summary.png": "b18e",
	"./employee-monitoring/reports/no-emp-activity-hours.png": "25ad",
	"./employee-monitoring/reports/no-team-activity-hours.png": "881e",
	"./employee-monitoring/reports/no-team-activity-percentage.png": "b4c1",
	"./employee-monitoring/reports/productive-unproductive-summary.png": "b3cb",
	"./employee-monitoring/reports/productivity-apps.png": "039f",
	"./employee-monitoring/reports/productivity-summary.png": "35c1",
	"./employee-monitoring/reports/productivity-urls.png": "31bd",
	"./employee-monitoring/reports/time-activity-reports.png": "3cbf",
	"./employee-monitoring/reports/unproductive-apps-urls-reports.png": "ac21",
	"./employee-monitoring/reports/urls-reports.png": "0372",
	"./employee-monitoring/reports/web-and-file.png": "44cc",
	"./employee-monitoring/reports/web-event.png": "b005",
	"./employee-monitoring/reports/weekly-calendar.png": "e709",
	"./employee-monitoring/reports/weekly-summary.png": "8621",
	"./employee-monitoring/stealth-mode/consent-based-bg-lower.png": "99f4",
	"./employee-monitoring/stealth-mode/consent-based-bg-upper.png": "ed51",
	"./employee-monitoring/stealth-mode/consent-based-tracking.png": "5e1f",
	"./employee-monitoring/stealth-mode/invite-admin-members.png": "91bd",
	"./employee-monitoring/stealth-mode/no-admins.png": "5eca",
	"./employee-monitoring/stealth-mode/no-records-admin-invites.png": "797c",
	"./employee-monitoring/stealth-mode/no-records-assets.png": "81cc",
	"./employee-monitoring/stealth-mode/no-team-members.png": "e62a",
	"./employee-monitoring/stealth-mode/stealth-mode-bg-lower.png": "b81b",
	"./employee-monitoring/stealth-mode/stealth-mode-bg-upper.png": "67e9",
	"./employee-monitoring/stealth-mode/stealth-mode-tracking.png": "3780",
	"./employee-monitoring/workforce-analytics/workforce-analytics.png": "720a",
	"./employees/goals-and-achievement/no-goals-assigned.png": "48ad",
	"./employees/goals-and-achievement/no-monthly-team-rating.png": "9089",
	"./employees/goals-and-achievement/no-yearly-team-rating.png": "58cb",
	"./employees/rewards-and-recognition/motivosity-logo.png": "5238",
	"./employees/rewards-and-recognition/rewards.png": "d758",
	"./layout/access-denied.png": "92ba",
	"./layout/announcement-icon.png": "40ff",
	"./layout/announcement.png": "c249",
	"./layout/cloud-bg.png": "e28e",
	"./layout/demo-booking-left-info.png": "478b",
	"./layout/demo-booking-right-info.png": "6a27",
	"./layout/demo-booking.png": "7e3a",
	"./layout/money-bag.png": "51ec",
	"./layout/networkError.png": "e262",
	"./layout/notification-icon.png": "5541",
	"./layout/page-not-found.png": "a9ade",
	"./layout/park-green-bg.png": "29e3",
	"./payroll/overtime-claim/approval-warning.png": "6ba2",
	"./payroll/overtime-claim/overtime-empty-img.png": "8a50",
	"./payroll/salary-template/new-template.png": "de68",
	"./settings/apps.png": "8cd6",
	"./settings/tax/it-declaration-locked.png": "f27b",
	"./settings/urls.png": "6029",
	"./shift-scheduling/beach.png": "af22",
	"./shift-scheduling/moon.png": "d887",
	"./shift-scheduling/shift-alert.png": "25da",
	"./shift-scheduling/shift-empty-image.png": "2d5f",
	"./shift-scheduling/shift-option.png": "524d",
	"./shift-scheduling/shift-scheduling.png": "7fec",
	"./shift-scheduling/shift-validation-success.png": "684a",
	"./shift-scheduling/shift-week-off-option.png": "b14d",
	"./shift-scheduling/week-off-option.png": "0a6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";